import { render, staticRenderFns } from "./ProjectDeleteDialog.vue?vue&type=template&id=48c4e1e0&"
import script from "./ProjectDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports